module.exports = __webpack_public_path__ + "img/1584829751.09c83c38.jpg";